"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeCollection = exports.deserializeAllTraits = exports.deserializeFeePercentage = exports.deserializeTokenData = exports.findLastActionTaken = exports.deserializeLastOffer = exports.deserializeFees = exports.deserializeLastSale = exports.deserializeOffers = exports.deserializeOfferStatus = exports.deserializeTokenTraits = exports.deserializeListingPrice = exports.deserializeListing = exports.deserializeListingStatus = exports.getResultStatus = exports.unwrap = void 0;
const status_codes_1 = require("../constants/status-codes");
const unwrap = (optional) => {
    return optional.length ? optional[0] : undefined;
};
exports.unwrap = unwrap;
const getResultStatus = (result, successMapper) => {
    var _a;
    if ('Ok' in result) {
        const response = { ok: true };
        if (successMapper) {
            response.data = successMapper(result.Ok);
        }
        return response;
    }
    if ('Err' in result) {
        const error = result.Err;
        const errorKey = (_a = Object.keys(error)) === null || _a === void 0 ? void 0 : _a[0];
        if (errorKey) {
            return { ok: false, error: { type: errorKey, message: error[errorKey] } };
        }
    }
    return { ok: false };
};
exports.getResultStatus = getResultStatus;
const deserializeListingStatus = (status) => {
    return Object.keys(status)[0];
};
exports.deserializeListingStatus = deserializeListingStatus;
const deserializeListing = (listing) => {
    if (!listing)
        return undefined;
    return {
        status: (0, exports.deserializeListingStatus)(listing.status),
        fees: (0, exports.deserializeFees)(listing.fee),
        time: listing.time,
        seller: listing.seller,
        fungibleId: listing.fungible_id,
        price: listing.price
    };
};
exports.deserializeListing = deserializeListing;
const deserializeListingPrice = (listing) => {
    if (!listing)
        return undefined;
    return listing === null || listing === void 0 ? void 0 : listing.price;
};
exports.deserializeListingPrice = deserializeListingPrice;
const deserializeTokenTraits = (traits) => {
    if (!traits)
        return { filters: {} };
    let location;
    let thumbnail;
    const traitsObject = traits.reduce((result, [trait, value]) => {
        const traitValue = value;
        if (trait === 'location') {
            location = traitValue.TextContent;
        }
        if (trait === 'thumbnail') {
            thumbnail = traitValue.TextContent;
        }
        return Object.assign(Object.assign({}, result), { [trait]: traitValue.TextContent });
    }, {});
    return { location, thumbnail, filters: traitsObject };
};
exports.deserializeTokenTraits = deserializeTokenTraits;
const deserializeOfferStatus = (status) => {
    return Object.keys(status)[0];
};
exports.deserializeOfferStatus = deserializeOfferStatus;
const deserializeOffers = (offers) => {
    if (!offers)
        return [];
    return offers.map((offer) => ({
        status: (0, exports.deserializeOfferStatus)(offer.status),
        tokenId: offer.token_id,
        time: offer.time,
        tokenOwner: offer.token_owner,
        buyer: offer.buyer,
        fungibleId: offer.fungible_id,
        price: offer.price
    }));
};
exports.deserializeOffers = deserializeOffers;
const deserializeLastSale = (lastSale) => {
    if (!lastSale)
        return undefined;
    return lastSale;
};
exports.deserializeLastSale = deserializeLastSale;
const deserializeFees = (fees) => {
    return fees.map((fee) => ({
        type: fee[0],
        fungibleCanisterId: fee[1],
        percentage: (0, exports.deserializeFeePercentage)(fee[2])
    }));
};
exports.deserializeFees = deserializeFees;
const deserializeLastOffer = (offers, lastOfferTime) => {
    if (!offers || !lastOfferTime)
        return undefined;
    const lastOffer = offers.find((offer) => offer.time === lastOfferTime);
    return lastOffer === null || lastOffer === void 0 ? void 0 : lastOffer.price;
};
exports.deserializeLastOffer = deserializeLastOffer;
const findLastActionTaken = (modifiedTimes) => {
    const lastModifiedTimes = [];
    const { lastOfferTime, lastListingTime, lastSaleTime } = modifiedTimes;
    if (lastOfferTime) {
        lastModifiedTimes.push(Number(lastOfferTime.toString()));
    }
    if (lastListingTime) {
        lastModifiedTimes.push(Number(lastListingTime.toString()));
    }
    if (lastSaleTime) {
        lastModifiedTimes.push(Number(lastSaleTime.toString()));
    }
    const lastModifiedTime = Math.max(...lastModifiedTimes);
    if (lastSaleTime && Number(lastSaleTime.toString()) === lastModifiedTime) {
        return status_codes_1.NFTActionStatus.Sold;
    }
    if (lastOfferTime && Number(lastOfferTime.toString()) === lastModifiedTime) {
        return status_codes_1.NFTActionStatus.OfferReceived;
    }
    if (lastListingTime && Number(lastListingTime.toString()) === lastModifiedTime) {
        return status_codes_1.NFTActionStatus.ForSale;
    }
    return '';
};
exports.findLastActionTaken = findLastActionTaken;
const deserializeTokenData = (tokenData, collection) => {
    const { location, thumbnail, filters } = (0, exports.deserializeTokenTraits)((0, exports.unwrap)(tokenData.traits));
    const price = (0, exports.deserializeListingPrice)((0, exports.unwrap)(tokenData.listing));
    const lastListingTime = (0, exports.unwrap)(tokenData.last_listing_time);
    const listing = (0, exports.deserializeListing)((0, exports.unwrap)(tokenData.listing));
    const lastOffer = (0, exports.deserializeLastOffer)(tokenData.offers, (0, exports.unwrap)(tokenData.last_offer_time));
    const lastOfferTime = (0, exports.unwrap)(tokenData.last_offer_time);
    const offers = (0, exports.deserializeOffers)(tokenData.offers);
    const lastSaleTime = (0, exports.unwrap)(tokenData.last_sale_time);
    const lastSale = (0, exports.deserializeLastSale)((0, exports.unwrap)(tokenData.last_sale));
    const lastActionTaken = (0, exports.findLastActionTaken)({ lastOfferTime, lastListingTime, lastSaleTime });
    return {
        id: tokenData.id,
        collectionName: collection.name,
        location,
        thumbnail,
        traits: filters,
        price,
        lastListingTime,
        listing,
        lastOffer,
        lastOfferTime,
        offers,
        lastSaleTime,
        lastSale,
        lastActionTaken
    };
};
exports.deserializeTokenData = deserializeTokenData;
const deserializeFeePercentage = (fee) => {
    const numberValue = Number((fee * BigInt(100)) / BigInt(100));
    // Return the percentage
    return numberValue / 100;
};
exports.deserializeFeePercentage = deserializeFeePercentage;
const deserializeAllTraits = (traits) => {
    // location and thumbnail are not used as filters and are returned separately in NFTs
    // So I filter them here.
    const filteredTraits = traits.filter((trait) => trait[0] !== 'location' && trait[0] !== 'thumbnail');
    return filteredTraits.map((trait) => {
        const traitKey = trait[0];
        const traitValues = trait[1].map(([value, count]) => ({
            name: value.TextContent,
            tokenCount: count
        }));
        return { trait: traitKey, values: traitValues };
    });
};
exports.deserializeAllTraits = deserializeAllTraits;
const deserializeCollection = (collection) => {
    return {
        fee: (0, exports.deserializeFeePercentage)(collection.fee),
        creationTime: collection.creation_time,
        owner: collection.owner,
        id: collection.id,
        name: collection.name,
        marketplaceId: collection.marketplace_id,
        standard: collection.standard,
        fungibleVolume: collection.fungible_volume,
        fungibleStandard: collection.fungible_standard,
        fungibleId: collection.fungible_id,
        fungibleFloor: collection.fungible_floor,
        thumbnail: collection.thumbnail
    };
};
exports.deserializeCollection = deserializeCollection;
